import Icon from '@ant-design/icons'

const DashboardSVG = () => (
    <svg
        t='1663140948642'
        className='icon'
        viewBox='0 0 1024 1024'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
        p-id='7626'
    >
        <path
            d='M438.857143 508.571429l312 312q-60.571429 61.714286-141.428572 96T438.857143 950.857143q-119.428571 0-220.285714-58.857143T58.857143 732.285714 0 512t58.857143-220.285714T218.571429 132 438.857143 73.142857v435.428572z m106.857143 3.428571h441.714285q0 89.714286-34.285714 170.571429T857.142857 824z m405.142857-73.142857H512V0q119.428571 0 220.285714 58.857143T892 218.571429 950.857143 438.857143z'
            p-id='7627'
            fill='currentColor'
        ></path>
    </svg>
)

export const DashboardIcon = props => <Icon component={DashboardSVG} {...props} />
